module.exports = __webpack_public_path__ + "static/media/logo-호두랩스.970ee9ed.png";